import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "button"]
  static values = {
    currentYear: Number,
    url: String
  }

  handleClick(event) {
    event.preventDefault()

    const selectedYear = parseInt(this.selectTarget.value, 10)

    // Check if year is actually changing
    if (selectedYear === this.currentYearValue) {
      alert("Please select a different year than the current one.")
      return
    }

    // Prompt user to type "CONFIRM"
    const confirmation = prompt(
      `WARNING: This will change the tax year from ${this.currentYearValue} to ${selectedYear}.\n\n` +
      `Question text containing the tax year will be regenerated.\n\n` +
      `To proceed, please type "CONFIRM" (all caps):`
    )

    if (confirmation === "CONFIRM") {
      this.changeYear(selectedYear)
    }
  }

  async changeYear(newYear) {
    const button = this.buttonTarget
    const originalHTML = button.innerHTML

    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Changing...'

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ tax_year: newYear })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        alert(data.message)
        location.reload()
      } else {
        alert(`Error: ${data.message || 'Failed to change tax year'}`)
        button.disabled = false
        button.innerHTML = originalHTML
      }
    } catch (error) {
      console.error('Error changing tax year:', error)
      alert('An error occurred while changing the tax year')
      button.disabled = false
      button.innerHTML = originalHTML
    }
  }
}
